"use strict";
// Validation utilities for both frontend and backend
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCommunityLevel = exports.validateSubscriptionTier = exports.generateQueryHash = exports.normalizeQuery = exports.sanitizeInput = exports.validateUrl = exports.validateEmail = void 0;
const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
exports.validateEmail = validateEmail;
const validateUrl = (url) => {
    try {
        new URL(url);
        return true;
    }
    catch {
        return false;
    }
};
exports.validateUrl = validateUrl;
const sanitizeInput = (input) => {
    return input
        .trim()
        .replace(/[<>]/g, '') // Remove potential HTML
        .substring(0, 5000); // Limit length
};
exports.sanitizeInput = sanitizeInput;
const normalizeQuery = (query) => {
    return query
        .toLowerCase()
        .trim()
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};
exports.normalizeQuery = normalizeQuery;
/**
 * Simple hash function for query deduplication
 * Uses a fast, non-cryptographic hash suitable for caching keys
 * Works in both browser and Node.js environments
 */
const generateQueryHash = (query) => {
    const normalized = (0, exports.normalizeQuery)(query);
    // Simple djb2 hash - fast and good distribution for cache keys
    let hash = 5381;
    for (let i = 0; i < normalized.length; i++) {
        hash = ((hash << 5) + hash) + normalized.charCodeAt(i);
        hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash).toString(16);
};
exports.generateQueryHash = generateQueryHash;
const validateSubscriptionTier = (tier) => {
    return ['trial', 'basic', 'premium', 'professional'].includes(tier);
};
exports.validateSubscriptionTier = validateSubscriptionTier;
const validateCommunityLevel = (level) => {
    return [
        'curious_observer',
        'active_questioner',
        'discerning_mind',
        'truth_seeker',
        'wisdom_guide'
    ].includes(level);
};
exports.validateCommunityLevel = validateCommunityLevel;
//# sourceMappingURL=validation.js.map